import { render, staticRenderFns } from "./UserPlan.vue?vue&type=template&id=666a2a02&scoped=true"
import script from "./UserPlan.vue?vue&type=script&lang=js"
export * from "./UserPlan.vue?vue&type=script&lang=js"
import style0 from "./UserPlan.vue?vue&type=style&index=0&id=666a2a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a2a02",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
